export const LG_BREAK_POINT = 1025;

export const MD_BREAK_POINT = 744;

export const APP_HEADER_ID = 'app-header';

export const HEADER_ID = 'header';

export const CONTAINER_ID = 'container';

/***** Chat - Messsage Elements *****/
export const CHAT_HEADER_ID = 'chat-title';
export const CHAT_LIST_WRAPPER_ID = 'chat-wrapper-list';
export const CHAT_LIST_ID = 'chat-list';
export const CHAT_INPUT_WRAPPER_ID = 'input-wrapper';


/** Search Page **/
export const SEARCH_WRAPPER_ID = 'search-wrapper';
export const SEARCH_CONDITION_ID = 'search-conditions';
export const SEARCH_LIST_WRAPPER_ID = 'list-wrapper';
export const SEARCH_PAGE = {
    HEIGHT_OF_HEADER_LOGGED: 82,
    HEIGHT_OF_HEADER: 64,
    PADDING_OF_CONTENT: 10,
    MARGIN_VERTICAL_OF_CONTENT: 16,
    MARGIN_RIGHT_TAG: 4,
    PADDING_JOB_OFFER: 24,
    WIDTH_OF_THREE_DOT: 14
};

export const SOURCE_TRIGGER_SECTION = {
    SEARCH_CONDITION: 'search-condition',
    LIST: 'list'
};

/** Article Page **/
export const ARTICLE_WRAPPER_ID = 'article-wrapper';
export const ARTICLE_LIKE_BUTTON_ID = 'like-button';

/** Carousel feature */
export const CAROUSEL_CARD = 'carousel-card';
export const CAROUSEL_WRAPPER = 'carousel-wrapper';